import { Color } from 'three';
import { useGameStore } from '../../simulation/store';
import { isNight } from '../../simulation/systems/time';
import { colourForTime } from '../materials';

export function LightingRig() {
  const minuteOfDay = useGameStore((state) => state.time.minuteOfDay);
  const weather = useGameStore((state) => state.weather);
  const night = isNight(minuteOfDay);
  const sky = colourForTime(minuteOfDay, weather.cloudCover);
  const sunIntensity = night ? 0.28 : 1.6 - weather.cloudCover * 0.55;
  const ambient = night ? 0.58 : 0.9 - weather.cloudCover * 0.2;

  return (
    <>
      <color attach="background" args={[sky]} />
      <fog attach="fog" args={[new Color(weather.kind === 'fog' ? '#b9c5bd' : sky), 19, weather.kind === 'fog' ? 42 : 68]} />
      <hemisphereLight args={['#ffe8b8', '#4a664e', ambient]} />
      <directionalLight
        castShadow
        intensity={sunIntensity}
        position={[8, 18, 10]}
        shadow-mapSize-width={2048}
        shadow-mapSize-height={2048}
      />
      {night ? <pointLight position={[0, 8, 0]} intensity={1.2} color="#f3c66f" distance={32} /> : null}
    </>
  );
}
